import React from "react";
import PopupWrapper from "../popupWrapper/popupWrapper";
import "./credentialsPopup.css";
import { popupTexts } from "../../utils/constants";

const {
  REACT_APP_CUSTOMER_CREDENTIAL_MAIL_CONTENT_ONE: mailContentOne,
  REACT_APP_CUSTOMER_CREDENTIAL_MAIL_CONTENT_SECOND: mailContentSecond,
  REACT_APP_CUSTOMER_CREDENTIAL_MAIL_THANKS_ONE: mailThanksOne,
  REACT_APP_CUSTOMER_CREDENTIAL_MAIL_THANKS_SECOND: mailThanksSecond,
} = process.env;

const CredentialsPopup = ({ onClose, credentials, setWarningPopupVisible }) => {
  const handleSend = () => {
    setWarningPopupVisible(true);
    onClose();
  };

  return (
    <PopupWrapper onClose={onClose}>
      <div className="customer-credentials">
        <p className="credentials-header">Send PIN/Pwd to customer</p>
        {/* Mail Content */}
        <div className="customer-credentials-mail-content">
          <p className="customer-credentials-title">
            Hi {credentials?.customerName}
          </p>
          <p className="customer-credentials-content">{mailContentOne}</p>
          <p className="customer-credentials-content">{mailContentSecond}</p>
        </div>

        {/* PIN and Temp Password */}
        <div className="customer-credentials-pin">
          <p className="customer-credentials-password">
            Temporary Password: {credentials?.password}
          </p>
          <p className="customer-credentials-pin">
            Temporary PIN: {credentials?.pin}
          </p>
        </div>

        {/* Thanks Section */}
        <div className="customer-credentials-thanks">
          <p className="customer-credentials-content">{mailThanksOne}</p>
          <p className="customer-credentials-content">{mailThanksSecond}</p>
          <p className="customer-credentials-signature">Optimum Mobile</p>
        </div>

        {/* Action Buttons */}
        <div className="customer-credentials-action-buttons">
          <button
            className="button reject credentials_cancel"
            onClick={onClose}
          >
            {popupTexts.credentials_cancel}
          </button>
          <button className="button credentials_send" onClick={handleSend}>
            {popupTexts.credentials_send}
          </button>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default CredentialsPopup;
